// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"5710b994","269":"cc699384","448":"1c8dd416","915":"92e18dd4"}[chunkId] + ".chunk.js";
};